// Cookie name for tracking viewed articles
export const VIEWED_ARTICLES_COOKIE = "viewed_article"
